import { useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { Contact } from '../types/Contact';
import { toggleArchiveContactCore } from '../lib/contactsCore';

export interface UseContactArchivingProps {
    contact: Contact;
    onNotification: (message: string, type?: 'success' | 'error') => void;
    onSave: () => void;
    onClose: () => void;
}

export function useContactArchiving({ contact, onNotification, onSave, onClose }: UseContactArchivingProps) {
    const [isArchiving, setIsArchiving] = useState(false);

    const handleArchiveToggle = useCallback(async () => {
        setIsArchiving(true);
        try {
            const newArchivedState = !contact.is_archived;
            // Use core API for archive toggle
            await toggleArchiveContactCore(supabase as any, String(contact.id), newArchivedState);

            // Show internal confirmation message
            const action = newArchivedState ? 'archived' : 'unarchived';
            onNotification(`Contact ${action} successfully`, 'success');

            // Close modal and refresh data
            onSave();
            onClose();
        } catch (error) {
            console.error('Error toggling archive status:', error);
            onNotification('Failed to update contact status. Please try again.', 'error');
        } finally {
            setIsArchiving(false);
        }
    }, [contact.id, contact.is_archived, onNotification, onSave, onClose]);

    return {
        isArchiving,
        handleArchiveToggle
    };
}
